import {ofType} from 'redux-observable';
import {concat, EMPTY, from, of} from 'rxjs';
import {ajax} from 'rxjs/ajax';
import {catchError, mergeMap, timeout} from 'rxjs/operators';
import {AnyAction} from 'redux';
import * as LoginActions from '../actions/LoginActions';
import * as IntentsActions from '../actions/IntentsActions';
import * as MC from '../constants/MotorcreditConstants';

export const getIpEpic = action$ =>
    action$.pipe(ofType(LoginActions.SSO_GOT_TOKEN_BY_CODE.name),
        mergeMap((action: AnyAction) => {
            const url = 'https://api.ipify.org';
            return ajax({url, responseType: 'text'}).pipe(
                timeout(MC.TIMEOUT),
                mergeMap((response: any) => {
                    return concat(
                        of(IntentsActions.GOT_IP_ACTION.action(response.xhr.responseText)),
                    );
                }),
                catchError(error => EMPTY)
            );
        })
    );

export const getGeoLocationEpic = action$ =>
    action$.pipe(
        ofType(LoginActions.SSO_GOT_TOKEN_BY_CODE.name),
        mergeMap(action =>
            from(promiseGeolocation()).pipe(
                mergeMap(response =>
                of(IntentsActions.GOT_GEOLOCATION_SUCCESS_ACTION.action(response))
            ),
            catchError((error) => {
                return EMPTY;
            }))
        )
    );

function promiseGeolocation() {
    const geolocation = navigator.geolocation;
    return new Promise((resolve, reject) => {
        if (!geolocation) {
            reject(new Error('Not Supported'));
        }

        geolocation.getCurrentPosition((position) => {
            resolve(position);
        }, () => {
            reject(new Error('Permission denied'));
        });
    });
}
